import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from "@angular/material/sort";
import { Contract } from 'src/app/model/contract';
import { InvoiceItems } from 'src/app/model/invoiceItems';
import { Company } from 'src/app/model/company';
import { environment } from 'src/environments/environment';
import { SnackService } from 'src/app/services/snack.service';
import { InvoiceSetupService } from "../../../services/invoice-setup.service";
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvoiceItemsArray } from 'src/app/model/invoiceItemsArray';
import { InvoiceSetup } from 'src/app/model/invoiceSetup';
import { merge } from 'lodash-es';
import { Router } from '@angular/router';

@Component({
  selector: 'aw-invoices-setup',
  templateUrl: './invoices-setup.component.html',
  styleUrls: ['./invoices-setup.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ]
})
export class InvoicesSetupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  invoiceItems: Array<InvoiceItems>;
  ItemToAdd: InvoiceItems[] = [
    { id: 0, description: undefined, unitCost: undefined, units: 1 }
  ];
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  contracts: Contract[] = [];
  contract = new Contract;
  items: InvoiceItems[] = [];
  company = new Company;
  @Input() isRegistrationRequest = false;
  invoiceIdContractForm: UntypedFormGroup;
  invoiceSetupForm: UntypedFormGroup;
  invoiceItemsForm: UntypedFormGroup;
  recaptchaKey = environment.captchaKey;
  dataSourceItems: any;
  showTable!: boolean;
  statusMessage!: string;
  isLoaded: boolean = true;
  dataSourceItemToAdd: any;
  newItems!: InvoiceItems;
  invoiceItemForm!: Array<InvoiceItemsArray>;

  public headers = [
    'description',
    'unitCost',
    'Change',
    'Delete'
  ];

  displayedColumnsAddItem: string[] = [
    'description',
    'unitCost',
    'Save',
    'Cancel'
  ];



  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  private _liveAnnouncer: any;


  constructor(
    public tabGroup: MatTabsModule,
    private invoiceSetupService: InvoiceSetupService,
    private snackService: SnackService,
    private _formBuilder: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    public snackBarSave: MatSnackBar,
    private router: Router,
  ) {
    this.invoiceItems = new Array<InvoiceItems>();
    this.invoiceIdContractForm = this._formBuilder.group(
      {
        contractId: new UntypedFormControl(
          '',
          [
          ]
        ),
      });

    this.invoiceSetupForm = this._formBuilder.group(
      {
        addressLine1: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        city: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        codeSDI: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        country: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        description: new UntypedFormControl(
          '',
          [

          ]
        ),
        email: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.email
          ]
        ),
        identifier: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        pec: new UntypedFormControl(
          '',
          [
            Validators.email
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
          ]
        ),
        vatNumber: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        zipCode: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )

      }
    );
    this.invoiceItemsForm = this._formBuilder.group(
      {
        description: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        unitCost: new UntypedFormControl(
          0,
          [
          ]
        ),

        units: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      }
    );

  }

  @ViewChild(MatSort)
  sort!: MatSort;

  ngOnInit(): void {
    this.loadItems();
    this.dataSourceItems = new MatTableDataSource();
    this.invoiceItems = [];

    if (this.isRegistrationRequest) {
      this.invoiceSetupForm.addControl('recaptchaReactive', new UntypedFormControl(null, Validators.required));

    }

    this.invoiceSetupService.getAllContracts(
    )
      .subscribe(res => {
        this.contracts = res;
        console.log(this.contracts);
      });

  }

  public loadItems() {
    this.isLoaded = true;
    this.dataSourceItemToAdd = new MatTableDataSource(this.ItemToAdd);
    this.dataSourceItems = new MatTableDataSource(this.invoiceItems);
    this.dataSourceItems.paginator = this.paginator;
    console.log('dataSourceItemToAdd', this.dataSourceItemToAdd);
  }

  deleteItem(item: InvoiceItems) {

    const index = this.dataSourceItems.data.indexOf(item.id);
    this.dataSourceItems.data.splice(index, 1);
    this.dataSourceItems._updateChangeSubscription();


  }
  addItem(item: InvoiceItems) {
    console.log('sono addItem', item);
    if (item.description != null && item.unitCost != null && item.description != "" && item.unitCost != 0 && item.units != 0) {

      //QUI aggiungo item che arriva dal form dentro invoiceItems, non bisogna toccare datasource
      this.invoiceItems.push(item);
      this.ItemToAdd.pop();

      this.ItemToAdd.push(
        { id: 0, description: undefined, unitCost: undefined, units: 1 }
      );
      this.statusMessage = 'Item is saved';
      this.openSnackBar(this.statusMessage, "Success");
      console.log('this.dataSourceItemToAdd', this.dataSourceItemToAdd);
      console.log('this.dataSourceItems', this.dataSourceItems);
      this.loadItems();
      //this.dataSourceItems = new MatTableDataSource(this.addNewItem);   
    } else {
      this.openSnackBar("Please enter correct data", "Error")
    }

  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  selectContract(deviceValue: any) {
    console.log("select" + deviceValue)
    this.invoiceSetupService.getContractById(
      deviceValue
    )
      .subscribe(res => {
        this.contract = res;
        console.log("contract", this.contract);
        const company = this.contract.company;
        if (company != undefined) {
          this.company = company;
        }

        console.log(company)
      });

    this.loadItems();

  }

  description = new UntypedFormControl('', [Validators.required]);

  getErrorMessage() {
    return this.description.hasError('required') ? 'You must enter a value' :
      this.description.hasError('description') ? 'Not a valid description' : '';
  }

  unitCost = new UntypedFormControl('', [Validators.required]);

  show() {
    this.loadItems();
    this.showTable = true;
    this.ItemToAdd = [
      { id: 0, description: undefined, unitCost: undefined }
    ];

  }

  cancel() {
    this.loadItems();
    this.showTable = false;
  }

  _invoiceSetup = new InvoiceSetup();

  @Input() set invoiceSetup(value: InvoiceSetup) {
    this._invoiceSetup = merge(new InvoiceSetup(), value);
    this.invoiceSetupForm.patchValue(this._invoiceSetup);
  }

  saveInvoiceSetup(): void {
    //this.saving = true;
    const newInvoiceSetup = merge(new InvoiceSetup(), this._invoiceSetup, this.invoiceSetupForm.value);
    const contractId = this.contract.id;
    this.invoiceSetupService.createInvoiceSetup(newInvoiceSetup, this.dataSourceItems.data, contractId)
      .subscribe(res => {
        //this.saving = false;
        //this.saved.emit();
        console.log(res);
        this.openSnackBarSave('Invoice setup created!', "Success");
      }
        // ,
        //   err => {
        //     this.snackService.error('error');

        //     console.log('err', err)
        //   },
        //   () => {
        //     this.openSnackBarSave('Invoice setup created!', "Success");
        //   }
      );
  }
  //snackBar
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }


  openSnackBarSave(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    }).afterDismissed().subscribe(() => {
      this.router.navigate(['reserved/invoices/invoices-items']);
    });
  }

}
